module.exports = __webpack_public_path__ + "static/media/blueTheme-boy.f7ccad15.svg";